import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const ZONES = [
    {
        light: "#A13D4B",
        name: "RED",
        headline: "You're bleeding.",
        desc: "Money leaves faster than it arrives. No margin, no cushion — every month is a fire to put out. First we stop the bleed.",
    },
    {
        light: "#D48C3A",
        name: "AMBER",
        headline: "You're surviving.",
        desc: "You're treading water. Bills are covered, but there's nothing left to build with. We turn survival into a system.",
    },
    {
        light: "#2D5A4C",
        name: "GREEN",
        headline: "You're building.",
        desc: "Money is working for you and real wealth is compounding. Now we accelerate — toward the goal, the move, the clarity.",
    },
];

export const Signal = () => {
    return (
        <section
            id="signal"
            data-testid="signal-section"
            className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32"
        >
            <div className="grid md:grid-cols-12 gap-8 items-end mb-16">
                <div className="md:col-span-8">
                    <p className="overline text-[#C5A059] mb-6">
                        — The Signal / Red · Amber · Green
                    </p>
                    <h2 className="font-display text-5xl md:text-7xl tracking-tight leading-[1.02] font-light">
                        Three lights. One{" "}
                        <span className="italic text-[#C5A059]">honest</span>{" "}
                        answer.
                    </h2>
                </div>
                <p className="md:col-span-4 font-body text-[#8E95A3] leading-relaxed">
                    I run your raw numbers and tell you exactly which light
                    you&apos;re on. No spin. No shame. Just the math.
                </p>
            </div>

            <div className="grid md:grid-cols-3 border-t border-l border-white/10">
                {ZONES.map((z, i) => (
                    <motion.div
                        key={z.name}
                        data-testid={`zone-${z.name.toLowerCase()}`}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, delay: i * 0.12, ease }}
                        className="group relative border-r border-b border-white/10 bg-[#11141D] p-9 md:p-11 overflow-hidden"
                    >
                        <span
                            className="absolute top-0 left-0 h-px w-full"
                            style={{
                                background: `linear-gradient(90deg, ${z.light}, transparent)`,
                            }}
                        />
                        <div className="flex flex-col gap-2.5 mb-8">
                            {ZONES.map((d) => (
                                <span
                                    key={d.name}
                                    className="w-3.5 h-3.5 rounded-full transition-all duration-500"
                                    style={{
                                        backgroundColor:
                                            d.name === z.name
                                                ? z.light
                                                : "rgba(255,255,255,0.07)",
                                        boxShadow:
                                            d.name === z.name
                                                ? `0 0 24px ${z.light}`
                                                : "none",
                                    }}
                                />
                            ))}
                        </div>

                        <p
                            className="font-mono text-xs tracking-[0.25em] mb-4"
                            style={{ color: z.light }}
                        >
                            {z.name} ZONE
                        </p>
                        <h3 className="font-display text-4xl md:text-5xl tracking-tight font-light mb-4">
                            {z.headline}
                        </h3>
                        <p className="font-body text-[#8E95A3] leading-relaxed">
                            {z.desc}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};
